import PublicHeader from "@/components/PublicHeader";
import PublicFooter from "@/components/PublicFooter";
import ChatWidget from "@/components/ChatWidget";
import Seo from "@/components/Seo";
import Editable from "@/components/Editable";
import { Heart } from "@phosphor-icons/react";

export default function NonAversive() {
  return (
    <div className="min-h-screen bg-[#FDFBF7]">
      <Seo title="Non-Aversive Training Policy | Puppl" description="Puppl uses non-aversive, fear-free, science-based training only. Read our full policy." canonical={typeof window !== "undefined" ? window.location.origin + "/non-aversive-policy" : ""} />
      <PublicHeader />
      <section className="max-w-3xl mx-auto px-6 lg:px-12 py-16">
        <div className="inline-flex items-center gap-2 bg-[#1b4a76]/10 text-[#1b4a76] px-4 py-1.5 rounded-full text-sm font-semibold mb-4">
          <Heart size={16} weight="duotone" /> <Editable id="nonaversive.badge" inline as="span" defaultHtml="Our commitment" />
        </div>
        <Editable id="nonaversive.heading" as="h1" className="font-heading text-4xl lg:text-5xl font-bold text-stone-900 mb-3" defaultHtml="Non-Aversive Training Policy" />
        <Editable id="nonaversive.subtitle" as="p" className="text-stone-500 text-sm mb-10" defaultHtml="Last updated: February 2026" />

        <div className="prose prose-stone max-w-none space-y-6 text-stone-700 leading-relaxed">
          <Editable id="nonaversive.intro" as="p" defaultHtml="At Puppl, we exclusively use <strong>non-aversive, fear-free, science-based training methods</strong>. We will never use, recommend or condone tools or techniques that cause fear, pain or intimidation." />

          <Editable id="nonaversive.section1.heading" as="h2" className="font-heading text-2xl font-bold text-stone-900 mt-8" defaultHtml="What this means in practice" />
          <Editable
            id="nonaversive.section1.body"
            as="ul"
            className="list-disc pl-6 space-y-2"
            defaultHtml="<li>We do not use, sell or recommend shock collars, prong collars, choke chains, citronella collars, or any tool designed to cause discomfort.</li><li>We do not use physical corrections, leash jerks, alpha rolls, or &quot;dominance&quot; techniques.</li><li>We teach through clear communication, positive reinforcement, management of the environment, and rewarding the behaviour we want to see more of.</li>"
          />

          <Editable id="nonaversive.section2.heading" as="h2" className="font-heading text-2xl font-bold text-stone-900 mt-8" defaultHtml="Why" />
          <Editable id="nonaversive.section2.body" as="p" defaultHtml="The scientific evidence is clear: fear-free, science-based training is at least as effective as aversive methods, with significantly lower risk of fear, anxiety and reactivity. We choose the method that&#39;s kinder, more reliable, and better for the long-term relationship between you and your dog." />

          <Editable id="nonaversive.section3.heading" as="h2" className="font-heading text-2xl font-bold text-stone-900 mt-8" defaultHtml="What we ask of clients" />
          <Editable id="nonaversive.section3.body" as="p" defaultHtml="Clients attending our group classes and private sessions are asked to commit to the same methods. We&#39;re always happy to help you transition away from aversive tools if you&#39;ve used them in the past." />
        </div>
      </section>
      <PublicFooter />
      <ChatWidget />
    </div>
  );
}
